import React from 'react';
import PropTypes from 'prop-types';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import URL from 'commons-garage/constants/url.js';
import config from 'commons-garage/config/index.js';
import 'commons-garage/components/GarageVehicle/GarageVehicle.scss';

const marketPlaceOrgId = 481;

const imagesServer = config.source.image;

function buildImageUrls(imagePath) {
    return {
        url: `${imagesServer}/${imagePath || ''}`,
        url360x270: `${imagesServer}/ir/w360h270/images/newcar/${imagePath || ''}`,
        url360x240: `${imagesServer}/ir/w360h197c/images/newcar/${imagePath || ''}`,
        url440: `${imagesServer}/ir/w440/images/newcar/${imagePath || ''}`,
    };
}

const VehicleImage = ({ quote, vehicle, isMultiDealerGarage }) => {
    const quoteExteriorSidePhoto =
        (quote.vehicle.exteriorColourPhotos &&
            quote.vehicle.exteriorColourPhotos.side &&
            buildImageUrls(quote.vehicle.exteriorColourPhotos.side)) ||
        {};

    const isCatalogDeskingQuote = quote.isCatalogDeskingQuote();

    const mainImage360x270 =
        (vehicle.multimedia && vehicle.multimedia.getMainImage360x270()) || quoteExteriorSidePhoto.url360x240;

    const mainImageURL = mainImage360x270 || `${imagesServer}/ir/w360h270/images/${URL.NO_PHOTO}`;

    const vehicleNoPhotoBackground = !mainImage360x270 ? 'no-photo has-secondary-background' : '';

    const vehicleImage = (
        <img className={vehicleNoPhotoBackground} alt={vehicle.getYearMakeModelTrim()} src={mainImageURL} />
    );

    const vehicleImageTile =
        !isCatalogDeskingQuote && (quote.isQuoteInPending() || vehicle.isAvailable()) ? (
            <a
                href={quote.getVDPUrl(
                    false,
                    isMultiDealerGarage && quote?.orgId === marketPlaceOrgId,
                    quote?.orgUnitId
                )}
            >
                {vehicleImage}
            </a>
        ) : (
            <span>{vehicleImage}</span>
        );

    return vehicleImageTile;
};

VehicleImage.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25).isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
};

VehicleImage.displayName = 'VehicleImage';

export default VehicleImage;
